import { render, staticRenderFns } from "./JumpTypeSelector.vue?vue&type=template&id=98498124&scoped=true"
import script from "./JumpTypeSelector.vue?vue&type=script&lang=js"
export * from "./JumpTypeSelector.vue?vue&type=script&lang=js"
import style0 from "./JumpTypeSelector.vue?vue&type=style&index=0&id=98498124&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98498124",
  null
  
)

export default component.exports